module.exports = __webpack_public_path__ + "img/20190815112810137.82ee4dd7.png";